import { formatDateTime, formatPercentageChange, formatYearMonth, formatJoinLeaveCompanyDate } from 'utils/format';
import React from 'react'
import { useSelector } from 'react-redux';
import { getItemsMonth, getItemsYear } from 'utils/util';
import CheckboxButton from '../../../../components/CheckboxButton';
import TextInput from '../../../../components/TextInput';
import Dropdown from '../../../../components/Dropdown';
import { STAFF_TYPE } from "../../../../constants/index";

const CareerProfileSection = ({ formData, setFormData, handleChangeForm, handleBlurInput, referrerTalentOptions, referrerTalentSearchText, setReferrerTalentSearchText, dayOptions, changeMonthLeaveCom, changeYearLeaveCom }) => {
  const { selectedTalent } = useSelector((state: any) => state.companyTalent);
  const {staffInfo} = useSelector((state: any) => state.currentUser);
  const yearOptions = getItemsYear(null);
  const monthOptions = getItemsMonth();

  return (
    <>
      <div className="mb-8 px-2">
        <h5 className="text-sm alu-text-base-2 font-bold mb-2">アクティビティ</h5>
        <div className="flex gap-6">
          <div className="ml-2 flex flex-col gap-3 shrink-0">
            <div className="flex items-center gap-1">
              <p className="shrink-0 min-w-[8.5rem] text-sm alu-text-base-1">最終アクセス日時</p>
              <p className="text-left flex-1 text-sm alu-text-base-2">
                {/* last access datetime value */}
                {selectedTalent?.talent?.last_access ? formatDateTime(selectedTalent?.talent?.last_access) : 'ー'} 
              </p>
            </div>
            <div className="flex gap-1">
              <p className="shrink-0 min-w-[8.5rem] text-sm alu-text-base-1">求人閲覧数 / 先週比<p className="text-xs">
              （過去7日間）</p></p>
              <p className="text-left flex-1 text-sm alu-text-base-2">
                {formatPercentageChange(selectedTalent?.job_view_last_7_day ? selectedTalent?.job_view_last_7_day : 0, selectedTalent?.job_view_last_7_day_before ? selectedTalent?.job_view_last_7_day_before : 0)}
              </p>
            </div>
            <div className="flex gap-1">
              <p className="shrink-0 min-w-[8.5rem] text-sm alu-text-base-1">アクセス数 / 先週比<p className="text-xs">
              （過去7日間）</p></p>
              <p className="text-left flex-1 text-sm alu-text-base-2">
                {selectedTalent?.access_count ? selectedTalent?.access_count : 'ー'}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-3 flex-1">
            <div className="flex items-center gap-1">
              <p className="shrink-0 min-w-[6.5rem] text-sm alu-text-base-1">アクセス頻度</p>
              <p className="text-left flex-1 text-sm alu-text-base-2">
                {selectedTalent?.talent?.activity_level ? selectedTalent?.talent?.activity_level : 'ー'}
              </p>
            </div>
            <div className="flex items-center gap-1">
              <p className="shrink-0 min-w-[6.5rem] text-sm alu-text-base-1">スカウト総数</p>
              <p className="text-left flex-1 text-sm alu-text-base-2">
                {/* number of scouts */}
                {selectedTalent?.scout_number ? selectedTalent?.scout_number : 'ー'}
              </p>
            </div>
            <div className="flex items-center gap-1">
              <p className="shrink-0 min-w-[6.5rem] text-sm alu-text-base-1">応募総数</p>
              <p className="text-left flex-1 text-sm alu-text-base-2">
                {/* number of apply job */}
                {selectedTalent?.apply_job_number ? selectedTalent?.apply_job_number : 'ー'}
              </p>
            </div>
            <div className="flex items-center gap-1">
              <p className="shrink-0 min-w-[6.5rem] text-sm alu-text-base-1">登録日時</p>
              <p className="text-left flex-1 text-sm alu-text-base-2">
                {/* registration datetime */}
                {selectedTalent?.created_at ? formatDateTime(selectedTalent?.created_at) : 'ー'}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-8 px-2">
        <h5 className="text-sm alu-text-base-2 font-bold mb-2">キャリア</h5>
        <div className="flex flex-col flex-wrap gap-2 ml-2">
          {(selectedTalent?.careers?.length > 0) ? (selectedTalent?.careers?.map((item: any, idx: any) => (
            <div key={idx} className="inline-flex gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <mask id="mask0_13103_9765" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                  <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_13103_9765)">
                  <path d="M8 10C8 11.1 8.39167 12.0417 9.175 12.825C9.95833 13.6083 10.9 14 12 14C13.1 14 14.0417 13.6083 14.825 12.825C15.6083 12.0417 16 11.1 16 10C16 8.9 15.6083 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C10.9 6 9.95833 6.39167 9.175 7.175C8.39167 7.95833 8 8.9 8 10ZM6 10C6 8.33333 6.58333 6.91667 7.75 5.75C8.91667 4.58333 10.3333 4 12 4C13.6667 4 15.0833 4.58333 16.25 5.75C17.4167 6.91667 18 8.33333 18 10C18 11.5 17.525 12.8042 16.575 13.9125C15.625 15.0208 14.4333 15.6917 13 15.925C13 15.925 12.3905 16 12 16C11.6095 16 11 15.925 11 15.925C9.56667 15.6917 8.375 15.0208 7.425 13.9125C6.475 12.8042 6 11.5 6 10Z" fill="#808080" />
                  <path d="M11 17H13V19H11V17Z" fill="#808080" />
                  <path d="M11 20H13V22H11V20Z" fill="#808080" />
                </g>
              </svg>
              <div>
                <p className="text-sm alu-text-base-2">{item?.description}</p>
                <p className="text-xs alu-text-base-1">{formatYearMonth(item?.join_date)}~{item?.leave_date ? formatYearMonth(item?.leave_date) : '現在'}</p>
              </div>
            </div>
          ))) : (
            <p className="text-sm alu-text-base-2">ー</p>
          )}
        </div>
      </div>

      <div className="mb-8 px-2 flex gap-4">
        <div className="flex-1">
          <h5 className="text-sm alu-text-base-2 font-bold mb-2">経験した職種</h5>
            {!selectedTalent?.talent?.profession_1?.name ? 
              <p className="text-sm alu-text-base-2 mb-1 ml-2">ー</p>
              :
              <>
                <p className="text-sm alu-text-base-2 mb-1 ml-2">
                  {selectedTalent?.talent?.profession_1?.name ? selectedTalent?.talent?.profession_1?.name : 'ー'}
                </p>
                <p className="text-sm alu-text-base-2 mb-1 ml-2">
                  {selectedTalent?.talent?.profession_2?.name ? ' > ' + selectedTalent?.talent?.profession_2?.name : 'ー'}
                </p>
                <p className="text-sm alu-text-base-2 ml-[0.875rem]">
                  {selectedTalent?.talent?.profession_3?.name ? ' > ' + selectedTalent?.talent?.profession_3?.name : 'ー'}
                </p>
              </>
            }
        </div>

        <div className="flex-1">
          <h5 className="text-sm alu-text-base-2 font-bold mb-2">経験した業種</h5>
            {!selectedTalent?.talent?.industry_1?.name ? 
              <p className="text-sm alu-text-base-2 mb-1 ml-2">ー</p>
              :
              <>
                <p className="text-sm alu-text-base-2 mb-1 ml-2">
                  {selectedTalent?.talent?.industry_1?.name ? selectedTalent?.talent?.industry_1?.name : 'ー'}
                </p>
                <p className="text-sm alu-text-base-2 mb-1 ml-2">
                  {selectedTalent?.talent?.industry_2?.name ? ' > ' + selectedTalent?.talent?.industry_2?.name : 'ー'}
                </p>
                <p className="text-sm alu-text-base-2 ml-[0.875rem]">
                  {selectedTalent?.talent?.industry_3?.name ? ' > ' + selectedTalent?.talent?.industry_3?.name : 'ー'}
                </p>
              </>
            }
        </div>
      </div>

      <div className="mb-8 px-2">
        <h5 className="text-sm alu-text-base-2 font-bold mb-2">リファラル</h5>
        <CheckboxButton
          id="isReferral"
          name="isReferral"
          value={formData.is_referred}
          label={"リファラル登録"}
          onChange={(e:any) => {setFormData((prev) => ({ ...prev, id: selectedTalent?.id, is_referred: !prev.is_referred }))}}
          disabled={!selectedTalent?.is_active || staffInfo?.type == STAFF_TYPE.GENERAL}
        />
        <div className="flex items-center mb-2 mt-2">
          <p className="min-w-[9.5rem] shrink-0 text-sm alu-text-base-1">紹介者（自由入力）</p>
          <p className="text-right flex-1 text-base alu-text-base-2">
            <TextInput
              size="md"
              type="text"
              id="referral_hiring"
              name="referral_hiring"
              value={formData.referral_hiring}
              maxLength={201}
              onChange={handleChangeForm}
              onBlur={handleBlurInput}
              onKeyDown={(e: any) => e.key === "Enter" && setFormData((prev) => ({
                ...prev,
                id: selectedTalent?.id
              }))}
              disabled={!selectedTalent?.is_active || staffInfo?.type == STAFF_TYPE.GENERAL}
            />
          </p>
        </div>
        <div className="flex items-center">
          <p className="min-w-[9.5rem] shrink-0 text-sm alu-text-base-1">紹介者（タレント）</p>
          <p className="text-left flex-1 text-base alu-text-base-2">
            <Dropdown
              clearable={selectedTalent?.is_active && staffInfo?.type != STAFF_TYPE.GENERAL}
              inputWidth="full"
              options={referrerTalentOptions}
              placeholder=""
              value={formData.referrer_talent}
              onChange={(value: any) => {
                setFormData((prev) => ({ ...prev, id: selectedTalent?.id, referrer_talent_id: value?.id, referrer_talent: value }))
              }}
              havingIcon={false}
              searchInput={true}
              searchQuery={referrerTalentSearchText}
              setSearchQuery={setReferrerTalentSearchText}
              noOptionsFoundText={referrerTalentSearchText ? '検索結果が見つかりませんでした' : 'タグが登録されていません'}
              optionStyles='px-2 py-[0.125rem] rounded-sm bg-[#F7F7F7] text-center'
              disabled={!selectedTalent?.is_active || staffInfo?.type == STAFF_TYPE.GENERAL}
            />
          </p>
        </div>
      </div>

      <div className="mb-8 px-2">
        <h5 className="text-sm alu-text-base-2 font-bold mb-2">アルムナイ</h5>
        <div className="flex gap-2 text-sm leading-[21px] mb-2">
          <p className="shrink-0 min-w-[7.5rem] alu-text-base-1">最終部署・社名</p>
          <p className="flex-1 alu-text-base-2">{selectedTalent?.department || 'ー'}</p>
        </div>
        <div className="flex items-center gap-2 text-sm leading-[21px] mb-2">
          <p className="shrink-0 min-w-[7.5rem] alu-text-base-1">退職日</p>
          <div className="flex items-top gap-2 md:w-[346px]">
            <div className="min-w-[96px]">
              <Dropdown
                inputWidth="full"
                placeholder={"ー"}
                options={yearOptions}
                value={formData.leave_company_year}
                unitLabel="年"
                onChange={(value: any) => changeYearLeaveCom(value, 'leave_company_year')}
                disabled={!selectedTalent?.is_active || staffInfo?.type == STAFF_TYPE.GENERAL}
                />
            </div>
            <div className="min-w-[80px]">
              <Dropdown
                inputWidth="full"
                placeholder={"ー"}
                options={monthOptions}
                value={formData.leave_company_month}
                unitLabel="月"
                onChange={(value: any) => changeMonthLeaveCom(value, 'leave_company_month')}
                disabled={!selectedTalent?.is_active || staffInfo?.type == STAFF_TYPE.GENERAL}
              />
            </div>
            <div className="min-w-[80px]">
              <Dropdown
                inputWidth="full"
                placeholder={"ー"}
                options={dayOptions}
                value={formData.leave_company_day}
                unitLabel="日"
                onChange={(value: any) => {
                  setFormData((prev) => ({
                    ...prev,
                    id: selectedTalent?.id, 
                    leave_company_day: value,
                  }));
                }}
                disabled={!selectedTalent?.is_active || staffInfo?.type == STAFF_TYPE.GENERAL}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-2 text-sm leading-[21px] mb-2">
          <p className="shrink-0 min-w-[7.5rem] alu-text-base-1">在籍期間</p>
          <p className="flex-1 alu-text-base-2">
            {formatJoinLeaveCompanyDate(selectedTalent?.join_company_year, selectedTalent?.join_company_month, selectedTalent?.leave_company_year, selectedTalent?.leave_company_month)}
          </p>
        </div>
        <div className="flex gap-2 text-sm leading-[21px]">
          <p className="shrink-0 min-w-[7.5rem] alu-text-base-1">退職理由</p>
          <div className="text-sm alu-text-base-2">
            {selectedTalent?.reason_resignation?.length > 0 ?
              <ul className="list-disc pl-5">
                {

                  selectedTalent?.reason_resignation?.split(' | ').map((reason: string, idx: number) =>
                    reason.trim() && (
                      <li key={idx} className="mb-1">
                        <pre className="">{reason.trim()}</pre>
                      </li>
                    )
                  )
                }
                </ul>
              : 'ー'}
          </div>
        </div>
      </div>

      <div className="mb-8 px-2">
        <h5 className="text-sm alu-text-base-2 font-bold mb-2">社内タレント</h5>
        <div className="flex items-center mb-2">
          <p className="min-w-[7.5rem] shrink-0 text-sm alu-text-base-1">社員番号</p>
          <p className="text-right flex-1 text-base alu-text-base-2">
            <TextInput
              size="md"
              type="text"
              id="employee_number"
              name="employee_number"
              value={formData.employee_number}
              maxLength={16}
              onChange={(e: any) => {
                const value = e.target.value;
                const regex = /^[A-Za-z0-9-_]*$/;

                if (regex.test(value) && value.length <= 16) {
                  handleChangeForm(e);
                }
              }}
              onBlur={handleBlurInput}
              onKeyDown={(e: any) => e.key === "Enter" && setFormData((prev) => ({
                ...prev,
                id: selectedTalent?.id
              }))}
              disabled={!selectedTalent?.is_active || staffInfo?.type == STAFF_TYPE.GENERAL}
            />
          </p>
        </div>
      </div>
    </>
  )
}

export default CareerProfileSection